import {useHydrationDone} from '@aboutyou/lazy-imports';
import {useIsArticleDetailPage} from '@aboutyou/router';
import {useFullSession, useUser} from '@aboutyou/user';
import {useRef} from 'react';
import {useProminentBannerSection as useProminentBannerSectionMinimal} from '../../backend-services/ArticleDetail/ProductInformationBox/MiniArticleDetail/useGetMinimalProductBulkSection';
import {useProminentBannerSection} from '../../backend-services/ArticleDetail/useGetProductBulkSection';
import {useDiscounts} from '../../backend-services/Campaigns/hooks/useDiscounts';

export const useCanShowCoupons = (): boolean => {
  const isHydrationDone = useHydrationDone();
  const user = useUser();
  const session = useFullSession();
  const prominentBannerSection = useProminentBannerSection();
  const discounts = useDiscounts();
  const isRendered = useRef(false);
  const isArticleDetailPage = useIsArticleDetailPage();
  const isFetchedAfterMountRef = useRef(false);

  if (isRendered.current) {
    return true;
  }

  if (!isHydrationDone) {
    return false;
  }

  if (user.isLoading) {
    return false;
  }

  if (discounts.isFetching || discounts.data?.discount) {
    return false;
  }

  if (!session) {
    return false;
  }

  if (
    !prominentBannerSection.isFetchedAfterMount &&
    !isFetchedAfterMountRef.current
  ) {
    isFetchedAfterMountRef.current = true;
    return false;
  }

  if (
    (prominentBannerSection.isFetching || prominentBannerSection.isStale) &&
    isArticleDetailPage
  ) {
    return false;
  }

  isRendered.current = true;

  return true;
};

export const useCanShowCouponsMinimal = (productId: number): boolean => {
  const isHydrationDone = useHydrationDone();
  const user = useUser();
  const session = useFullSession();
  const prominentBannerSection = useProminentBannerSectionMinimal(productId);
  const discounts = useDiscounts();
  const isRendered = useRef(false);

  if (isRendered.current) {
    return true;
  }

  if (!isHydrationDone) {
    return false;
  }

  if (user.isLoading) {
    return false;
  }

  if (discounts.isFetching || discounts.data?.discount) {
    return false;
  }

  if (!session) {
    return false;
  }

  if (prominentBannerSection.isFetching || prominentBannerSection.isStale) {
    return false;
  }

  isRendered.current = true;

  return true;
};
